import { breakpoints } from '@ecommerce/shared'
import styled, { css } from 'styled-components'

interface StyledInputProps {
  hasError?: boolean
}

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
`

export const InputWrapper = styled.div<StyledInputProps>`
  position: relative;
  height: 40px;
  ${({ hasError }) => {
    if (hasError) {
      return css`
        padding-bottom: 4rem;
        @media (${breakpoints.desktop.min}) {
          padding-bottom: 3.5rem;
        }
      `
    }
  }}
  .text-field {
    .TextFieldComponent__Base {
      font-size: 12px;
      line-height: 16px;
    }

    input {
      transition: border-color 0.2s ease-in-out;
      padding-right: 90px;
      border: 1px solid ${({ theme }) => theme.colors.grey};
    }
    input:focus {
      outline: none;
      border: 1px solid ${({ theme }) => theme.colors.black};
    }
    input:not(:placeholder-shown) {
      border: 1px solid ${(props) => (props.hasError ? props.theme.colors.error : props.theme.colors.green60)};
    }
    &--error {
      input {
        border-color: ${({ theme }) => theme.colors.error};
      }
    }
  }
`

export const SaveButton = styled.button`
  color: ${({ theme }) => theme.colors.red};
  background: none;
  border: none;
  position: absolute;
  right: 0;
  top: 14px;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  :disabled {
    cursor: default;
  }

  &:disabled {
    color: ${(props) => props.theme.colors.platinum60};
    cursor: not-allowed;
  }
`

export const ErrorMessage = styled.p`
  font-size: 12px;
  color: ${(props) => props.theme.colors.error};
  margin-top: 0.25rem;
  min-height: 1.25rem;
`
